import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73743f39"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "role-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "role-table"
};
import { ref, markRaw } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useRoleStore from '@/store/modules/role';
import { storeToRefs } from 'pinia';
import protoPagination from '@/components/proto-pagination.vue';
import { setStatusApi, deleteRoleApi } from '@/service/modules/role';
import { ElMessage, ElMessageBox } from 'element-plus';
import { QuestionFilled } from '@element-plus/icons-vue';
import roleDialog from './components/role-dialog.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'role',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const roleStore = useRoleStore();
    const page = ref({
      page: 1,
      pageSize: 15
    });
    const {
      roleList,
      roleListTotal
    } = storeToRefs(roleStore);
    const roleDialogVisible = ref(false);
    const roleDialogType = ref('add');
    const roleDialogData = ref({});
    initData();
    async function initData() {
      await roleStore.getAllPermissionListAction();
      roleStore.getRoleListAction(page.value);
    }
    function restData() {
      closeRoleDialog();
      page.value.page = 1;
      roleStore.getRoleListAction(page.value);
    }
    function handleRoleTableCurrentChange(val) {
      page.value.page = val;
      roleStore.getRoleListAction(page.value);
    }
    function handleRoleTableItem(item) {
      roleDialogType.value = 'edit';
      roleDialogData.value = item;
      roleDialogVisible.value = true;
    }
    function deleteRoleTableItem(id) {
      ElMessageBox.confirm('此操作将永久删除该数据, 是否继续？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteRoleApi(id);
          ElMessage.success('删除成功');
          restData();
        } catch {}
      }).catch(() => {});
    }
    function handleRoleDialog() {
      roleDialogType.value = 'add';
      roleDialogVisible.value = true;
    }
    function closeRoleDialog() {
      roleDialogType.value = 'add';
      roleDialogData.value = {};
      roleDialogVisible.value = false;
    }
    async function handleTableSattusChange(item) {
      console.log('item', item);
      let query = {
        id: item.id,
        status: item.status
      };
      try {
        let res = await setStatusApi(query);
        ElMessage.success('操作成功');
        restData();
      } catch {}
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode("角色管理 "), _createVNode(_component_el_button, {
        onClick: handleRoleDialog,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("新增")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_unref(roleList).length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: _unref(roleList),
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.value.page - 1) * page.value.pageSize), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "创建时间",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "是否启用",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event,
            "active-value": 1,
            "inactive-value": 0,
            onChange: $event => handleTableSattusChange(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleRoleTableItem(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => deleteRoleTableItem(scope.row.id)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])) : _createCommentVNode("", true)]), _createVNode(protoPagination, {
        page: page.value,
        total: _unref(roleListTotal),
        onCurrentChange: handleRoleTableCurrentChange
      }, null, 8, ["page", "total"]), _createVNode(roleDialog, {
        "dialog-visible": roleDialogVisible.value,
        "dialog-type": roleDialogType.value,
        "item-data": roleDialogData.value,
        onCloseDialog: closeRoleDialog,
        onRestData: restData
      }, null, 8, ["dialog-visible", "dialog-type", "item-data"])]);
    };
  }
});